import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InitialsAvatarComponent} from './initials-avatar.component';

@NgModule({
  imports: [CommonModule, InitialsAvatarComponent],
  exports: [InitialsAvatarComponent]
})
export class InitialsAvatarModule {}
